import _ from "lodash";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useRef } from "react";
import Logo from "../../assets/images/LogoNew.svg";
import { InputField } from "../../components";
import CountrySelectCyclos from "../../components/CSC/CountrySelect/CountrySelectCyclos";
import CountrySelectService from "../../components/CSC/CountrySelect/CountrySelectService";
import LanguagePicker from "../../components/LanguagePicker/LanguagePicker";
import { DialogContext } from "../../store/context/DialogContext";
import { useTranslation } from "../../store/context/TranslationContext";
import { UserContext } from "../../store/context/UserContext";
import { buildAutomationChildTestId } from "../../components/InputField/testId";
import ButtonGroupNew from "../Form/forms/BusinessLiteForms/components/ButtonGroupNew";
import { validateEmail } from "./Auth";
import GCaptcha from "./GCaptcha";
import "./LoginCredentials.scss";

const LoginCredentials = (props) => {

  const { userContent, populateUserContent } = useContext(UserContext);
  const { t } = useTranslation()
  const { showError } = useContext(DialogContext);

  const {
    getOTP,
    data,
    hasErr,
    setData,
    loading,
    errorStatus,
    isCpanelLogin,
    form,
    errorMessage,
    selecteToggle,
    recaptchaToken,
    setRecaptchaToken,
    shouldByPassCaptcha,
    testId,
  } = props;
  const credentialsTestId = buildAutomationChildTestId(testId, "credentials");
  const countryFieldTestId = buildAutomationChildTestId(testId, "country-of-residence");
  const emailFieldTestId = buildAutomationChildTestId(testId, "email");

  const loginData = useRef(
    isCpanelLogin
      ? {
        email: "",
        password: "",
        captchaQuery: "",
      }
      : {
        authType: "password",
        countryCode: 91,
        password: "",
        language: "en",
        phone: null,
        email: "",
        emailPhone: "",
        captchaQuery: "",
        captcha_id: " ",
      }
  );

  const sendOtp = async () => {
    if (form?.formType == "INDIVIDUAL_PLUS") {
      try {
        if (!data?.country) {
          showError("Please select country of residence");
          return
        }
        if (CountrySelectService.cyclosCountryMaster.length == 0) await CountrySelectService.fetchCyclosCountryMaster();
        if (CountrySelectService?.cyclosCountryMasterMap?.[data?.country]?.[CountrySelectService.COUNTRY_MASTER_KEYS?.BANK_ACCOUNT] !== "Yes") {
          showError(`We are sorry to inform you that we currently do not support banking in your country.`);
          return
        }
        getOTP();
      } catch (error) {
        showError(error);
      }
    } else {
      getOTP();
    }
  };

  useEffect(() => {
    document.body.className = "authentication-bg";

    return function cleanup() {
      document.body.className = "";
    };
  }, []);

  useEffect(() => {
    const myBtn = document.getElementById("captcha");
    if (errorStatus) {
      myBtn.click();
    }
  }, [errorStatus]);

  const isDisabledCountry = () => {
    if (form?.formType == "INDIVIDUAL_PLUS") {
      return !data?.country
    }
    return false
  }

  return (
    <div className="" data-testid={credentialsTestId}>
      <div className="form-content-container" data-testid={buildAutomationChildTestId(credentialsTestId, "container")}>
        <div className='form-content-header' data-testid={buildAutomationChildTestId(credentialsTestId, "header")}>
          <img
            src={Logo}
            alt={t("fv-bank")}
            className="logo logo-dark form-content-logo"
            data-testid={buildAutomationChildTestId(credentialsTestId, "logo")}
          />
          <div className=''><LanguagePicker testId={buildAutomationChildTestId(testId, "language")} /></div>
        </div>

        <div className="form-content-body with-shadow compact " data-testid={buildAutomationChildTestId(credentialsTestId, "card")}>
          <div className='form-content-body-header' data-testid={buildAutomationChildTestId(testId, "title")}>
            {t(form?.name)}
          </div>
          <div className='form-content-body-content' data-testid={buildAutomationChildTestId(credentialsTestId, "content")}>
            <div>
              <div className="form-content-body-content-desc" data-testid={buildAutomationChildTestId(credentialsTestId, "description")}>
                <div data-testid={buildAutomationChildTestId(credentialsTestId, "welcome-message")}>{t("Welcome!")}</div>
                <div data-testid={buildAutomationChildTestId(credentialsTestId, "instruction")}>{t("Confirm your email to continue")}</div>
              </div>
              <div className="form-horizontal " data-testid={buildAutomationChildTestId(credentialsTestId, "form")}>
                <div className="text-center mt-2">
                  <div className="">
                    {form?.formType == "INDIVIDUAL_PLUS" && <div className="d-flex align-items-center text-start" data-testid={buildAutomationChildTestId(credentialsTestId, "country-section")}>
                      <CountrySelectCyclos
                        id={countryFieldTestId}
                        showErr={hasErr}
                        value={data?.country}
                        className="col-12"
                        label={t("Country of Residence")}
                        placeholder={t("Country of Residence")}
                        error={!data?.country ? t("Please select Country of Residence") : ""}
                        onChange={(v) => {
                          setData({ ...data, country: v?.value });
                        }}
                        innerContainerStyle={{ backgroundColor: "#F1FAFC", borderRadius: "14px", border: "1px solid #C6F3FF" }}
                      />

                    </div>}
                    <div className="d-flex align-items-center" data-testid={buildAutomationChildTestId(credentialsTestId, "email-section")}>
                      <InputField
                        id={emailFieldTestId}
                        value={data?.email}
                        label={t("Email Address")}
                        placeholder={t("user@gmail.com")}
                        type="email"
                        showErr={hasErr}
                        isDisabled={form?.type == "kyc" && !form?.allowKycEmailInput}
                        onChange={(v) => {
                          const lowerCaseEmail = _.toLower(v);
                          setData({ ...data, email: lowerCaseEmail });
                          loginData.current = {
                            ...loginData.current,
                            email: lowerCaseEmail,
                          };
                        }}
                        inputFieldStyle={{ backgroundColor: "#F1FAFC", borderRadius: "14px", border: "1px solid #C6F3FF" }}
                        className="col-12"
                        error={!validateEmail(data?.email) ? t("Please enter valid email") : ""}
                      />
                    </div>
                    <div className="d-flex justify-content-center my-3" data-testid={buildAutomationChildTestId(credentialsTestId, "recaptcha-section")}>
                      <GCaptcha
                        onChange={setRecaptchaToken}
                        onExpired={() => setRecaptchaToken("")}
                        testId={buildAutomationChildTestId(testId, "recaptcha")}
                      />
                    </div>
                    {errorMessage?.captchaQuery ? (
                      <div
                        data-testid={buildAutomationChildTestId(testId, "recaptcha-error")}
                        style={{
                          color: "red",
                          marginLeft: "30px",
                          fontSize: "10px",
                        }}
                      >
                        {errorMessage?.captchaQuery}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="mt-4 mb-3 w-100 ">

                  <ButtonGroupNew
                    onNextClick={sendOtp}
                    step={2}
                    nextText={t("Send OTP")}
                    asLabel={false}
                    testId={buildAutomationChildTestId(testId, "credentials-actions")}
                    primaryActionTestIdSuffix="send-otp"
                    isDisabled={shouldByPassCaptcha ? false : (loading || (selecteToggle && (!recaptchaToken || isDisabledCountry() || !data?.email)))}
                    loading={loading}
                    hideBackButton
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-3 text-center" data-testid={buildAutomationChildTestId(testId, "version")}>
          <p className="font-size-16">
            Version 1.0.0
          </p>
        </div>
      </div>
    </div >
  );
};

export default observer(LoginCredentials);
